import React, {PropsWithChildren} from 'react';

import {
  SnackbarProvider as NotistackProvider,
  SnackbarKey,
  SnackbarMessage,
  OptionsObject,
} from 'notistack';

import CloseIcon from '@mui/icons-material/CloseRounded';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {neutral} from '../theme';

export type EnqueueSnackbar = (
  message: SnackbarMessage,
  options?: OptionsObject,
) => SnackbarKey;

const SnackbarProvider: React.FC<PropsWithChildren> = ({children}) => {
  const notistackRef = React.useRef<NotistackProvider>(null);
  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key);
  };
  return (
    <NotistackProvider
      ref={notistackRef}
      action={key => (
        <IconButton onClick={onClickDismiss(key)}>
          <CloseIcon sx={{color: neutral.white}} />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
};

export const SnackbarContent = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => (
  <Stack>
    <Typography variant="subtitle2">{title}</Typography>
    <Typography data-testid="snackbar-message">{message}</Typography>
  </Stack>
);

export default SnackbarProvider;
